import React, { Component } from "react";

import { Container } from "reactstrap";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
  getPaymentFormulasForId,
  getPaymentFormulasParams,
  patchPaymentFormulas,
  setErrorPaymentFormulas
} from "../../../store/payment-formula/actions";
import PaymentFormulasCalculator from "../AddPaymentFormulas/components/PaymentFormulasCalculator";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

class PaymentFormulasProfile extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getPaymentFormulasForId(this.props.match.params.formulaId);
    this.props.getPaymentFormulasParams();
  }

  componentWillUnmount() {
    this.props.setErrorPaymentFormulas(false);
  }

  render() {
    const data = this.props.data;
    const formulaId = this.props.match.params.formulaId;
    const isError = this.props.isError;

    if (isError) {
      return (
        <Redirect to={"/404"} />
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
        <ModifiedMetaTags title="Payment formula profile | Mobihunter" />

          <Container fluid>
            <Breadcrumbs title="Payment formula" breadcrumbItem={data?.formula} link="/payment-formulas" />
            <PaymentFormulasCalculator profileData={data}
                                       data={this.props.paymentData}
                                       formulaTableData={this.props.formulaData}
                                       patchPaymentFormulas={this.props.patchPaymentFormulas}
                                       history={this.props.history}
                                       formulaId={formulaId}
                                       permissions={this.props.permissions}
            />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

PaymentFormulasProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      formulaId: PropTypes.node
    }).isRequired
  }).isRequired,
  getPaymentFormulasForId: PropTypes.func,
  patchPaymentFormulas: PropTypes.func,
  setErrorPaymentFormulas: PropTypes.func,
  getPaymentFormulasParams: PropTypes.func,
  history: PropTypes.any,
  data: PropTypes.any,
  formulaData: PropTypes.any,
  paymentData: PropTypes.any,
  isError: PropTypes.any,
  permissions: PropTypes.any
};

const mapStateToProps = state => ({
  data: state.PaymentFormulas.payment_formula,
  formulaData: state.PaymentFormulas.data,
  paymentData: state.PaymentFormulas.absolute_params,
  isError: state.PaymentFormulas.isError,
  permissions: state.User.permissions,
});

export default withRouter(
  connect(mapStateToProps, {
    getPaymentFormulasForId,
    patchPaymentFormulas,
    setErrorPaymentFormulas,
    getPaymentFormulasParams,
  })(PaymentFormulasProfile)
);
